import { c as create_ssr_component, s as subscribe, e as escape, a as add_attribute } from "../../chunks/ssr.js";
/* empty css                 */
import "vanilla-lazyload";
import { p as page } from "../../chunks/stores.js";
const Layout = create_ssr_component(($$result, $$props, $$bindings, slots) => {
  let $page, $$unsubscribe_page;
  $$unsubscribe_page = subscribe(page, (value) => $page = value);
  let { data } = $$props;
  let jsonLdScript = "";
  function getStructuredData() {
    if ($page.data.seo !== void 0) {
      let jsonLdString = JSON.stringify($page.data.seo.structuredData);
      jsonLdScript = `

     <script type="application/ld+json">

       ${jsonLdString}

     ${"<"}/script>

   `;
    }
  }
  if ($$props.data === void 0 && $$bindings.data && data !== void 0) $$bindings.data(data);
  {
    if ($page.data.seo !== void 0) {
      getStructuredData();
    }
  }
  $$unsubscribe_page();
  return `${$$result.head += `<!-- HEAD_svelte-1y7qiib_START -->${$$result.title = `<title>${escape($page.data.seo !== void 0 ? $page.data.seo.metaTitle : "Medium Sans - Serif, Gallery - Art Contemporain")}</title>`, ""}<meta name="description"${add_attribute(
    "content",
    $page.data.seo !== void 0 ? $page.data.seo.metaDescription : "Maison d'édition et de diffusion de la création contemporaine.",
    0
  )}><meta name="keywords"${add_attribute(
    "content",
    $page.data.seo !== void 0 ? $page.data.seo.metaKeywords : "maison edition, genève, artistes contemporain, artistes émergents",
    0
  )}><link rel="canonical"${add_attribute(
    "href",
    $page.data.seo !== void 0 ? $page.data.seo.canonicalUrl : "https://mediumsans.com",
    0
  )}><!-- HTML_TAG_START -->${jsonLdScript}<!-- HTML_TAG_END --><!-- HEAD_svelte-1y7qiib_END -->`, ""} <main class="block h-screen overflow-hidden inset-0 w-full bg-white bg-[radial-gradient(#e5e7eb_1px,transparent_1px)] [background-size:16px_16px]"><div class="h-full w-full bg-transparent/20"><div class="h-[calc(100vh-20px)] w-full px-5 pb-5 pt-3">${slots.default ? slots.default({}) : ``}</div></div></main>`;
});
export {
  Layout as default
};
